module.exports = __webpack_public_path__ + "img/weddings_25_V.8b557ba5.webp";